export const reviewsData = [
  {
    link: "https://search.google.com/local/reviews?placeid=ChIJDZbF04sNlVQRbsAJdqiC_uw",
    src: "https://tomedes.gumlet.io/assets/images/reviews-images-updated/Review_US.svg",
    alt: "google reviews USA",
  },
  {
    link: "https://search.google.com/local/reviews?placeid=ChIJV2mjZn1LHRURjGNyBoW-qUs",
    src: "https://tomedes.gumlet.io/assets/images/reviews-images-updated/Review_IL.svg",
    alt: "google reviews Israel",
  },
  {
    link: "https://clutch.co/profile/tomedes-1#reviews",
    src: "https://tomedes.gumlet.io/assets/images/reviews-images-updated/clutch.svg",
    alt: "clutch reviews",
  },
  {
    link: "https://www.goodfirms.co/company/tomedes",
    src: "https://tomedes.gumlet.io/assets/images/reviews-images-updated/goodfirms.svg",
    alt: "goodfirms reviews",
  },
  {
    link: "https://www.trustpilot.com/review/www.tomedes.com",
    src: "https://tomedes.gumlet.io/assets/images/reviews-images-updated/trustpilot.svg",
    alt: "trustpilot reviews",
  },
  {
    link: "https://www.g2.com/products/tomedes/reviews",
    src: "https://tomedes.gumlet.io/assets/images/g2_review.svg",
    alt: "g2 reviews",
  },
  {
    link: "https://www.facebook.com/Tomedes.translation/reviews",
    src: "https://tomedes.gumlet.io/assets/images/facebook_review.svg",
    alt: "fb reviews",
  },
  {
    link: "https://www.featuredcustomers.com/vendor/tomedes",
    src: "https://tomedes.gumlet.io/assets/images/featured_review.svg",
    alt: "featured reviews",
  },
];
